module.exports = __webpack_public_path__ + "static/media/ke.5d45eaae.svg";